import React from 'react';
import { Card } from '../../components/ui/card';

export function ProgressAnalysisSkeleton() {
    return (
        <div className="border-t-1 border-b-1 py-3 px-4 md:px-2 md:border-none">
            <div className="flex justify-between items-center mb-2">
                <div className="h-7 w-48 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                <div className="h-9 w-32 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
            </div>

            <div className="flex gap-2 mb-6">
                <div className="h-10 w-40 bg-[var(--q3-surface-dimmer)] rounded-full"></div>
                <div className="h-10 w-28 bg-[var(--q3-surface-dimmer)] rounded-full"></div>
                <div className="h-10 w-32 bg-[var(--q3-surface-dimmer)] rounded-full"></div>
                <div className="h-10 w-32 bg-[var(--q3-surface-dimmer)] rounded-full"></div>
            </div>

            <div className="flex gap-6 overflow-hidden pb-4 h-full">
                {[1, 2, 3].map((i) => (
                    <Card
                        key={i}
                        className="bg-[var(--q3-surface-default)] shadow-none rounded-md border-t-4 border-l-2 border-r-2 border-b-2 flex-shrink-0 w-[331.5px] h-[150px] flex flex-col items-start justify-center p-0"
                        style={{ borderTopColor: 'var(--q3-surface-dimmer)' }}
                    >
                        <div className="flex flex-row items-center w-full justify-between px-3 mb-2">
                            <div className="h-6 w-32 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                            <div className="h-8 w-8 bg-[var(--q3-surface-dimmer)] rounded-full"></div>
                        </div>
                        <div className="w-full px-3 mb-2">
                            <div className="flex items-center w-full gap-5">
                                <div className="h-10 w-24 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                                <div className="flex flex-nowrap gap-8">
                                    <div className="text-xs text-left">
                                        <div className="h-4 w-10 bg-[var(--q3-surface-dimmer)] rounded-md mb-1"></div>
                                        <div className="h-4 w-12 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                                    </div>
                                    <div className="text-xs text-left">
                                        <div className="h-4 w-10 bg-[var(--q3-surface-dimmer)] rounded-md mb-1"></div>
                                        <div className="h-4 w-12 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="px-3 w-full">
                            <div className="h-4 w-24 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
}